const EVENT_TIME_FIELDS = [
  'createtime', 'updatetime', 'create_time', 'update_time', 'created_time', 'updated_time',
  'pay_time', 'paid_time', 'refund_time', 'cost_time', 'audit_time', 'order_audit_time',
  'logintime', 'jointime', 'prevtime', 'accepted_at', 'sent_at', 'delivered_at',
  'cancelled_at', 'completed_at', 'processed_at', 'event_utc', 'timestamp',
  'sendtime', 'paytime', 'ordertime', 'settlement_time', 'inbound_time', 'uploadtime',
  'finishtime', 'expiretime', 'deletetime', 'refreshtime', 'ctime', 'fba_end_time',
  'addtime',
];

export function isValidTimeZone(timeZone) {
  if (!timeZone) return false;
  if (timeZone !== 'UTC' && timeZone !== 'Etc/UTC') {
    if (!/^[A-Za-z_]+\/[A-Za-z0-9_+\-\/]+$/.test(timeZone) || /^Etc\/GMT[+\-]/i.test(timeZone)) return false;
  }
  try {
    new Intl.DateTimeFormat('en-US', { timeZone }).format();
    return true;
  } catch (e) {
    return false;
  }
}

export function getDeviceTimeZone() {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return isValidTimeZone(timeZone) ? timeZone : 'UTC';
  } catch (e) {
    return 'UTC';
  }
}

function getSavedUserInfo() {
  try {
    return JSON.parse(window.localStorage.getItem('userInfo1')) || {};
  } catch (e) {
    return {};
  }
}

/** Store → User → Device/Browser → UTC。 */
export function getDisplayTimeZone(context = {}) {
  const user = getSavedUserInfo();
  const candidates = [
    context.store_timezone,
    user.store_timezone,
    context.display_timezone,
    context.user_timezone,
    user.user_timezone,
    user.timezone,
    user.display_timezone,
    getDeviceTimeZone(),
    'UTC',
  ];
  return candidates.find(isValidTimeZone) || 'UTC';
}

function parseEventTime(value) {
  if (value == null || value === '') return null;
  if (value instanceof Date) return value;
  if (typeof value === 'number' || /^\d{9,13}$/.test(String(value))) {
    const number = Number(value);
    return new Date(String(Math.trunc(number)).length === 10 ? number * 1000 : number);
  }
  const text = String(value).trim();
  const hasTimeZone = /(?:Z|[+\-]\d{2}:?\d{2})$/i.test(text);
  const normalized = hasTimeZone ? text : text.replace(' ', 'T') + 'Z';
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatEventTime(value, timeZone, withSeconds = false) {
  const date = parseEventTime(value);
  if (!date) return value || '';
  const zone = isValidTimeZone(timeZone) ? timeZone : getDisplayTimeZone();
  const options = {
    timeZone: zone,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  };
  if (withSeconds) options.second = '2-digit';
  const parts = new Intl.DateTimeFormat('en-CA', options).formatToParts(date)
    .reduce((result, item) => ({ ...result, [item.type]: item.value }), {});
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}${withSeconds ? `:${parts.second}` : ''}`;
}

function isEventField(key, parent) {
  const field = String(key).replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase();
  return EVENT_TIME_FIELDS.includes(field)
    || field.endsWith('_at')
    || (field === 'time' && parent && Object.prototype.hasOwnProperty.call(parent, 'local_time'));
}

/**
 * 将 API 的 UTC 事件时间统一转成最终显示 timezone；q_date/q_time/shipment_date 等业务本地时间不转换。
 */
export function normalizeApiTimes(value, inheritedTimeZone) {
  if (Array.isArray(value)) {
    return value.map((item) => normalizeApiTimes(item, inheritedTimeZone));
  }
  if (!value || typeof value !== 'object') return value;
  const timeZone = getDisplayTimeZone({ ...value, display_timezone: value.display_timezone || inheritedTimeZone });
  Object.keys(value).forEach((key) => {
    if (Array.isArray(value[key]) || (value[key] && typeof value[key] === 'object')) {
      value[key] = normalizeApiTimes(value[key], timeZone);
    } else if (isEventField(key, value)) {
      value[key] = formatEventTime(value[key], timeZone, key === 'create_time' || key === 'update_time');
    }
  });
  return value;
}
